module.exports = __webpack_public_path__ + "static/media/image2.b1e39e74.png";